import React, { Component } from 'react';
import { connect } from "react-redux";
import intl from 'react-intl-universal';
import Box from '@mui/material/Box';
import AccountInfo from './AccountInfo'
 
class AccountDash extends Component {

    render () {  
        
        return (
          <Box  sx={{ p: 2, border: '1px dashed grey' }}>
          <h1>{intl.get('KONTO')}</h1>
              <AccountInfo />
          <hr /> 
             
          </Box>
        )
    }
}

const mapStateToProps = state => ({
    state: state,
    apitoken: state.gettocken.apitoken
  });





export default connect(mapStateToProps)(AccountDash);
